<script lang="ts" setup>
import { Mutations, ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';
import OrganizationForm from '../organizations/OrganizationForm.vue';
import { NEW_ID } from '@/util/constants';
import { Organization } from '@/models/organization.model';

const store = useStore<ShiftCMSState & { us: UsersState }>();

const communities = computed<Organization[]>(
  () => store.state.us.organizations,
);

const update = () => {
  store.dispatch(UsersActions.GetOrganizationsList);
};

const addOrganization = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(OrganizationForm),
    data: {
      id: NEW_ID,
      name: '',
      webToken: '',
      users: [],
    },
  });
};

function editOrganization(evt: Event, { item }: { item: Organization }) {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(OrganizationForm),
    data: item,
  });
}

onMounted(() => {
  update();
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
});

const headers = [
  { title: 'ID', key: 'id', width: '5%' },
  { title: 'Name', key: 'name', width: '15%' },
  { title: 'Users', key: 'users', width: '15%' },
  { title: 'Places', key: 'initiatives', width: '15%' },
  { title: 'Events', key: 'events', width: '15%' },
];
</script>
<template>
  <v-container>
    <h2>Organizations</h2>

    <v-data-table
      density="compact"
      @click:row="editOrganization"
      :headers="headers"
      :items="communities"
      hover
    >
      <template v-slot:item.users="{ item }">
        {{ item.users.length }}
      </template>
      <template v-slot:item.initiatives="{ item }">
        {{ item.initiatives.length }}
      </template>
      <template v-slot:item.events="{ item }">
        {{ item.events.length }}
      </template>
    </v-data-table>

    <v-btn @click="addOrganization" color="success">Add Organization</v-btn>
  </v-container>
</template>
<style scoped>
.date {
  font-size: 70%;
}
</style>
